import React from "react";
import {
  SpecialisedStructuredData,
  SpecialisedStructuredDataModuleProps
} from "../../../components/SpecialisedStructuredData";
import { IModule } from "../types";

export type GetSpecialisedStructuredDataProps =
  IModule<SpecialisedStructuredDataModuleProps>;

export const getSpecialisedStructuredData: React.FC<GetSpecialisedStructuredDataProps> = (props) => (
  <SpecialisedStructuredData type={props.type} />
);
